import CheckboxInput from 'components/input/CheckboxInput';
import React, {useState} from 'react';
import {roomTypeList} from './SearchContainer';
import {ReactComponent as InfoIcon} from '../../assets/icons/ic_info.svg';

interface RoomTypeModalProps {
  roomType: string[];
  setRoomType: (roomType: string[]) => void;
}

const RoomTypeModal = ({roomType, setRoomType}: RoomTypeModalProps) => {
  const [isError, setIsError] = useState(false);

  const handleChecked = (checked: boolean, type: string) => {
    if (roomType.length === 1 && !checked) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setRoomType(checked ? [...roomType, type] : roomType.filter(t => t !== type));
  };

  return (
    <div className='flex w-full flex-col gap-y-2.5 pb-[30px] pl-[30px] pr-5 pt-5'>
      <div className='flex w-full flex-col gap-y-1'>
        <h5 className='flex h-close items-center text-b3'>Room Type</h5>
        {isError && (
          <div className='flex items-center gap-x-1.5 text-primary'>
            <InfoIcon width={21} height={21} />
            <p className='text-c2'>You must select at least one option.</p>
          </div>
        )}
      </div>
      <div className='flex w-full flex-col gap-y-2 text-c3'>
        {roomTypeList.map(type => (
          <CheckboxInput
            key={type}
            checked={roomType.includes(type)}
            setChecked={checked => handleChecked(checked, type)}
          >
            {type}
          </CheckboxInput>
        ))}
      </div>
    </div>
  );
};

export default RoomTypeModal;
